<div class="container">
  <div class="prev-cont" *ngIf="prevBut === true" (click)="prev()"><img src="/assets/icons/arrow-left-icon.svg" /></div>
  <div class="close-cont" *ngIf="closeBut === true" (click)="close()"><img src="/assets/icons/close-icon.svg" /></div>
  <div class="progress-cont" *ngIf="progresBar"></div>
</div>
